/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type CeproDocsImportInterruptPartialUpdateRequest = {} | null | undefined;
export type CeproDocsImportInterruptPartialUpdateResponse = any;

export type CeproDocsImportInterruptPartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/cepro_docs/{id}/import_interrupt/
 *
 * ```yaml
 * operationId: cepro_docs_import_interrupt_partial_update
 * tags:
 *   - cepro_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const ceproDocsImportInterruptPartialUpdateOperation = ({
  id,
  ...rest
}: CeproDocsImportInterruptPartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/cepro_docs/${id}/import_interrupt/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/cepro_docs/{id}/import_interrupt/' };
  };

/**
 * PATCH /dmx-server/cepro_docs/{id}/import_interrupt/
 *
 * ```yaml
 * operationId: cepro_docs_import_interrupt_partial_update
 * tags:
 *   - cepro_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const ceproDocsImportInterruptPartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: CeproDocsImportInterruptPartialUpdateQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = ceproDocsImportInterruptPartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
